module.exports = __webpack_public_path__ + "img/bg25.2261fca8.png";